<template>
  <v-row no-gutters>
    <v-col>
      <!-- tool bar -->
      <v-card
          color="grey lighten-4"
          flat
          style="margin-bottom: 6px;"
          tile
      >
        <v-app-bar
          dense
          fixed
          color="elevation-1"
          style="margin-top:70px;"
        >
        <v-row no-gutters>
            <v-col class="d-flex pa-0">
              <v-autocomplete
                v-model="report_selected"
                label="All Reports"
                :items="report_list"
                item-text="name"
                item-value="id"
                dense
                solo
                clearable
                hide-details
                style="max-width:340px"
              >
                <template
                  slot="selection"
                  slot-scope="data"
                >
                  <div>
                    <div v-html="data.item.name" />
                  </div>
                </template>
              </v-autocomplete>

              <div style="margin-left:16px">
                <v-btn @click="onPreviosRange">
                  <v-icon>mdi-menu-left</v-icon>
                </v-btn>

                <v-menu
                  v-model="menu_date_picker"
                  transition="scale-transition"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on">
                      {{dateRangeText(date_range_selected)}}
                    </v-btn>
                  </template>

                  <v-card max-width="346px">
                    <v-date-picker
                      v-model="date_range_selected"
                      scrollable
                      actions
                      full-width
                      first-day-of-week="1"
                      range
                      :title-date-format="dateRangeText"
                    ></v-date-picker>

                    <v-divider></v-divider>
                  </v-card>
                </v-menu>

                <v-btn @click="onNextRange">
                  <v-icon>mdi-menu-right</v-icon>
                </v-btn>
              </div>

              <v-select
                v-model="interval_selected_id"
                :items="interval_list"
                item-text="name"
                item-value="id"
                @change="onSelectInterval"
                dense
                solo
                hide-details
                style="max-width:150px; margin-left:16px;"
              ></v-select>
            </v-col>
          </v-row>
        </v-app-bar>
      </v-card>
      <div
        class="d-flex mb-auto"
        flat
        tile
      >
        <!-- right panel work area -->
        <v-card
          color="elevation-0"
          class="panel-invoices"
        >
          <v-card
            color="elevation-1"
            width="100%"
            class="time-sheet-table"
            style="margin-bottom:3px;"
            tile
          >
            <!-- headers -->
            <v-card
              color="elevation-1"
              class="time-sheet-table__header"
              style="margin-bottom:10px;font-weight: bold;"
              tile
            >
              <v-row no-gutters>
                <v-col class="custom-width" cols="12" sm="6" md="1">Date</v-col>
                <v-col class="padding-decrease" cols="12" sm="6" md="1">Driver</v-col>
                <v-col class="custom-width" cols="12" sm="6" md="1">Amount Charged</v-col>
                <v-col class="custom-width" cols="12" sm="6" md="1">Amount Paid</v-col>
                <v-col class="custom-width" cols="12" sm="6" md="1">Difference</v-col>
                <v-col cols="12" sm="6" md="2">Restaurant</v-col>
                <v-col cols="12" sm="6" md="1">Shift Time</v-col>
                <v-col cols="12" sm="6" md="1">Created Date</v-col>
                <v-col cols="12" sm="6" md="3">Comment</v-col>
                <v-col class="padding-decrease" cols="12" sm="6" md="1">Creator</v-col>
              </v-row>
            </v-card>
            <!--/ headers -->
            <!-- body -->
            <v-card
              color="elevation-1"
              style="margin-bottom: 1px;"
              no-gutters
              tile
              class="time-sheet-table__line"
              v-for="item in reportsSearched"
              :key="item.id || item.label"
              :class="{
                'negative-difference': item.amount_difference < 0,
                'positive-difference': item.amount_difference > 0,
                'zero-difference': item.amount_difference == 0,
                'total-row': item.isTotalRow // Add a class for styling total row
              }"
             >
              <v-row align="stretch">
                <v-col class="custom-width" cols="12" sm="6" md="1">{{item.label || getDateFormat(item.period_date, "YYYY-MM-DD HH:mm:ss")}}</v-col>
                <v-col class="padding-decrease" cols="12" sm="6" md="1">{{getDriverByID(item.driver_id)}}</v-col>
                <v-col class="custom-width" cols="12" sm="6" md="1">{{item.cost_cover}}</v-col>
                <v-col class="custom-width" cols="12" sm="6" md="1">{{item.amount_paid}}</v-col>
                <v-col class="custom-width" cols="12" sm="6" md="1">{{item.amount_difference}}</v-col>
                <v-col cols="12" sm="6" md="2">{{getRestaurantNameByID(item.restaurant_id)}}</v-col>
                <v-col cols="12" sm="6" md="1">{{item.emptyLine || getShiftHours(item.model ? item.model : item)}}</v-col>
                <v-col cols="12" sm="6" md="1">{{item.emptyLine || getDateFormat(item.updated_at, "YYYY-MM-DD HH:mm:ss")}}</v-col>
                <v-col cols="12" sm="6" md="3">{{item.emptyLine || item.comment_cancelled}}</v-col>
                <v-col class="padding-decrease"  cols="12" sm="6" md="1">{{ creator(item.moderator_id || (item.model && item.model.moderator_id) || '') }}</v-col>
              </v-row>
            </v-card>
            <!--/ body -->
          </v-card>
          <!--/ right panel work area -->
        </v-card>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import moment from 'moment';
import Vue from 'vue';
import * as _ from 'lodash';
import { mapGetters } from 'vuex';
import { DATE_RANGE_HELPERS,
         INTERVAL_DAY, INTERVAL_WEEK, INTERVAL_TWO_WEEK, INTERVAL_MONTH
       } from '../../store/shifts';
import { mapActions } from 'vuex/dist/vuex.common.js';

const SHIFT_CANCELLED = 'shifts_cancelled';
const SHIFT_EXTRA_REQUEST = 'extra_request'; //Fetching from its own table
const SHIFT_CHARGE_REMOVED = 'shifts_charge_removed';
const SHIFT_INACTIVE_FEE = 'shifts_inactive_fee';

const INSERTED = 10;
const UPDATED = 20;
const DELETED = 30;
const CANCELLED = 40;

export default {
  name: "Reporting",
  data: () => ({
    // const list for template
    interval_list: [
      { id: INTERVAL_DAY, name: 'Day', $isDisabled: true },
      { id: INTERVAL_WEEK, name: 'Week' },
      { id: INTERVAL_TWO_WEEK, name: '2-Week' },
      { id: INTERVAL_MONTH, name: 'Month' },
    ],
    report_list: [
      { id: SHIFT_CANCELLED, name: 'Shift Cancelled/Bonus Added'},
      { id: SHIFT_EXTRA_REQUEST, name: 'Extra Request'},
      { id: SHIFT_CHARGE_REMOVED, name: 'Charge Removed'},
      { id: SHIFT_INACTIVE_FEE, name: 'Drivers Inactive with Cancellation Fee'},
    ],
    states: {
      [SHIFT_EXTRA_REQUEST]: 'shift_extra_request_list',
      [SHIFT_CANCELLED]: 'shift_cancelled_list',
      [SHIFT_CHARGE_REMOVED]: 'shift_charge_removed_list',
      [SHIFT_INACTIVE_FEE]: 'shift_inactive_fee_list',
    },
    // ---
    localLoading: true,
    report_selected: null,
    date_range_selected: null,
    period_date_selected: null,
    menu_date_picker: false,
    interval_selected_id: INTERVAL_WEEK, // default week
  }),
  computed: {
    ...mapGetters({
      restaurant_list: 'restaurants',
      driver_list: 'drivers',
      shift_extra_request_list: 'extra_request',
      shift_cancelled_list: 'shifts_cancelled',
      shift_charge_removed_list: 'shifts_charge_removed',
      shift_inactive_fee_list: 'shifts_inactive_fee'
    }),
    ...mapGetters("user", {
            users: "users",
        }),
    reportsSearched() {
      if (this.localLoading) {
        // If either list is empty, return an empty result or handle it accordingly
        return [];
      }
      let shifts = [];
      if (this.$data.report_selected !== void 0) {
        shifts = this.states[this.$data.report_selected]; //gets the list name from current report_selected within the states
      }
      // shifts = _.orderBy(result, p => p.period_date_from);
      shifts = _.orderBy(this[shifts], p => p.period_date); // Result contains list name and fetches the global list using this keyword
      if (['extra_request','shifts_charge_removed','shifts_inactive_fee'].includes(this.$data.report_selected)) {
        return shifts;
      }

      // Get the timesheets and shifts list from the state
      let timesheets = this.$store.state.timesheets.timesheetforReports || [];
      //let shifts = this.$store.state.reporting.shiftCancelled || [];
      // Check if both timesheets and shifts are available and not empty
      
      // Combine the lists based on shift_id and create separate rows for timesheet and shift
      let combinedResults = [];
      let totalPaid = 0;
      let totalFeeEarned = 0;
      let totalAmountDifference = 0;
      let modifiedShift = 0;
      
      shifts.forEach(shift => {
        const timesheetFound = timesheets.find(timesheets => timesheets.modified_shift_id === shift.shift_id);
        // Push the corresponding shift as a separate row
        if (timesheetFound) {
          if(modifiedShift === timesheetFound.modified_shift_id)
            return;
          let amountDifference = parseFloat(shift.cost) - parseFloat(timesheetFound.cost_extra_bonus);
          totalPaid += parseFloat(timesheetFound.cost_extra_bonus); // Add to totalFeeEarned
          modifiedShift = timesheetFound.modified_shift_id;
          if (shift.cost < 0) {
            amountDifference = (timesheetFound.cost_extra_bonus - Math.abs(shift.cost)) * -1;
          }
          totalAmountDifference += amountDifference; // Add to totalAmountDifference

          combinedResults.push({
            type: 'shift',
            ...timesheetFound,
            amount_difference: amountDifference,  // Add the calculated difference
            amount_paid: parseFloat(timesheetFound.cost_extra_bonus),  // Add the calculated difference
          });
        }

        let cost = parseFloat(shift.cost) * -1; // cost cover
        // Add shift cost/fee to totalPaid/totalFeeEarned
        let key = 'amount_paid';
        if (shift.cost < 0) {
          totalFeeEarned += parseFloat(shift.cost) * -1;
          key = 'cost_cover';
        } else {
          totalPaid += parseFloat(shift.cost);
          cost = parseFloat(shift.cost);
        }
        totalAmountDifference = totalFeeEarned - totalPaid;// show profit/loss

        // Push the timesheet row first
        combinedResults.push({
          type: 'timesheet',
          ...shift,
          [key]: cost,  // Dynamic key value based on cost/fee
        });

        //this.localLoading = true;
    });

    if (combinedResults.length > 0) {
      combinedResults = _.orderBy(combinedResults, p => p.period_date);
    
      // Push the timesheet row first
      combinedResults.push({
          type: 'total',
          cost_cover: totalFeeEarned.toFixed(2),   // Display totalPaid with 2 decimal places
          amount_difference: totalAmountDifference.toFixed(2),  // Display totalFeeEarned with 2 decimal places
          amount_paid: totalPaid.toFixed(2),  // Add the calculated difference
          label: 'Total',
          isTotalRow: true,// Flag to identify this as a total row
          emptyLine: '-' // Flag to identify this as a total row
        });
    }
    return combinedResults;
    }
  },
  watch: {
    period_date: function(period_date_new) {
      if (this.$data.period_date_selected != period_date_new) {
        this.$data.period_date_selected = period_date_new;
      }
    },
    report_selected(newVal, oldVal) {
    if (newVal !== oldVal && this[this.states[this.$data.report_selected]].length == 0) {
      this.fetchData();
    }
  },
  },
  mounted() {
    Promise.all([
      this.$store.dispatch('user/fetchUsers'),
      this.$store.dispatch('fetchDrivers'),
      this.$store.dispatch('fetchRestaurants') // fetch data for modal
    ]);
    // fill example data
    let current_date = moment();
    // this.$data.interval_selected_id = this.$data.interval_list[1].id; // 1 - one week
    this.$data.date_range_selected = [current_date.startOf('isoWeek').format('YYYY-MM-DD'), null];
    this.$data.report_selected = this.report_list[0].id;
    this.dateRangeSelect();

    this.fetchData(); //gets corresposnding list based on which report selected

  },
  methods: {
    dateRangeSelect: async function() {
      this.$data.date_range_selected = this.dayToRange(this.$data.date_range_selected[0], this.$data.interval_selected_id);
      this.fetchData();
    },
    fetchData: function() {
      this.localLoading = true; // Set loading state to true before fetchings
      switch(this.$data.report_selected) {
        case SHIFT_CANCELLED:
          if (this.shift_cancelled_list.length == 0) {
            Promise.all([
              this.$store.dispatch('fetchShiftCancelled', {
                period_date_from: this.$data.date_range_selected[0],
                period_date_to: this.$data.date_range_selected[1],
              }),
              this.$store.dispatch('fetchTimesheets', {
                period_date_from: this.$data.date_range_selected[0],
                period_date_to: this.$data.date_range_selected[1],
                for_reports: 1,
              })
            ]).then(() => {
              this.localLoading = false; // Set loading state to false after both list are fetched to ensure shifts and timesheet are processed and combined
            }).catch(error => {
              console.error('Error fetching data:', error);
              this.isLoading = false; // Still set to false even if there's an error
            });
          }
        break;
        case SHIFT_EXTRA_REQUEST:
          if (this.shift_extra_request_list.length == 0) {
            Promise.all([
              this.$store.dispatch('fetchShiftsExtraRequest',{
                period_date_from: this.$data.date_range_selected[0],
                period_date_to: this.$data.date_range_selected[1],
                extra_request: '1',
              })
            ]).then(() => {
              this.localLoading = false; // Set loading state to false
            }).catch(error => {
              console.error('Error fetching data:', error);
              this.isLoading = false; // Still set to false even if there's an error
            });
          }
        break;
        case SHIFT_CHARGE_REMOVED:
        if (this.shift_charge_removed_list.length == 0) {
            Promise.all([
              this.$store.dispatch('fetchShiftsChargeRemoved',{
                period_date_from: this.$data.date_range_selected[0],
                period_date_to: this.$data.date_range_selected[1],
                extra_request: '1',
              })
            ]).then(() => {
              this.localLoading = false; // Set loading state to false
            }).catch(error => {
              console.error('Error fetching data:', error);
              this.isLoading = false; // Still set to false even if there's an error
            });
          }
        break;
        case SHIFT_INACTIVE_FEE:
        if (this.shift_inactive_fee_list.length == 0) {
            Promise.all([
              this.$store.dispatch('fetchShiftsInactiveFee',{
                period_date_from: this.$data.date_range_selected[0],
                period_date_to: this.$data.date_range_selected[1],
                extra_request: '1',
              })
            ]).then(() => {
              this.localLoading = false; // Set loading state to false
            }).catch(error => {
              console.error('Error fetching data:', error);
              this.isLoading = false; // Still set to false even if there's an error
            });
          }
        break;
      }
    },
    clearStates(params) {
      this.$store.commit('clearStates', { params }); //clear all states on date interval change
    },
    onSelectInterval: function() {
      if (this.$data.interval_selected_id == INTERVAL_WEEK || this.$data.interval_selected_id == INTERVAL_TWO_WEEK || this.$data.interval_selected_id == INTERVAL_MONTH) { // reset to the start of week, if changed from day
        let date_to_shift = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
        this.$data.date_range_selected = [date_to_shift.startOf('isoWeek').format("YYYY-MM-DD"), null];
      }

      if (this.$data.interval_selected_id == INTERVAL_DAY) { // reset to the current day, if changed from week
        let current_day = moment();
          this.$data.date_range_selected = [current_day.format("YYYY-MM-DD"), null];
      }
      this.clearStates(this.report_list);
      Vue.nextTick(() => {
        this.dateRangeSelect();
      });
    },
    onPreviosRange: function() {
      let date_to_shift = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
      switch(this.$data.interval_selected_id) {
        case INTERVAL_DAY:
          date_to_shift.subtract(1, 'day');
          break;
        case INTERVAL_WEEK:
          date_to_shift.subtract(1, 'weeks');
          break;
        case INTERVAL_TWO_WEEK:
          date_to_shift.subtract(2, 'weeks');
          break;
        case INTERVAL_MONTH:
          date_to_shift.subtract(1, 'months');
          break;
      }

      // this.$data.date_range_selected
      this.clearStates(this.report_list);
      this.$data.date_range_selected = [date_to_shift.format("YYYY-MM-DD"), null];
      this.dateRangeSelect();
    },
    onNextRange: function() {
      let date_to_shift = moment(this.$data.date_range_selected[0], "YYYY-MM-DD");
      switch(this.$data.interval_selected_id) {
        case INTERVAL_DAY:
          date_to_shift.add(1, 'days');
          break;
        case INTERVAL_WEEK:
          date_to_shift.add(1, 'weeks');
          break;
        case INTERVAL_TWO_WEEK:
          date_to_shift.add(2, 'weeks');
          break;
        case INTERVAL_MONTH:
          date_to_shift.add(1, 'months');
          break;
      }

      // this.$data.date_range_selected
      this.clearStates(this.report_list);
      this.$data.date_range_selected = [date_to_shift.format("YYYY-MM-DD"), null];
      this.dateRangeSelect();
    },
    dayToRange: function(date, interval_id) {
        return DATE_RANGE_HELPERS.dayToRange(date, interval_id)
    },
    dateRangeText: function (date_range_selected) {
        return DATE_RANGE_HELPERS.dateRangeText(date_range_selected)
    },
    getPeriodDateText: function (period_date_selected) {
      return moment(period_date_selected, "YYYY-MM-DD").format('DD/MM/YYYY');
    },
    getRestaurantNameByID: function(restaurant_id) {
      let resturant = _.find(this.restaurant_list, p => +restaurant_id == +p.id);
      if (!resturant) {
        return '-';
      }

      return resturant.name;
    },
    getDriverByID: function(driver_id) {
      let driver = _.find(this.driver_list, p => +driver_id == +p.id);
      if (!driver) {
        return '-';
      }

      return driver.first_name  + ' ' + driver.last_name;
    },
    getShiftHours: function(p) {
      if (!p || !p.start_time || !p.finish_time) {
        return '-';
      }
      // Check if the times are valid before using moment.js
      const startTime = moment(p.start_time, "HH:mm:ss", true); // Strict parsing
      const finishTime = moment(p.finish_time, "HH:mm:ss", true); // Strict parsing

      // Return '-' if either time is invalid
      if (!startTime.isValid() || !finishTime.isValid()) {
        return '-';
      }

      // Return the formatted start and finish times
      return startTime.format('HH:mm') + '-' + finishTime.format('HH:mm');
    },
    getDateFormat: function(p, format) {
      return moment(p, format).format("DD/MM/YY");
    },
    creator(id) {
      let user = _.find(this.users, p => p.id == id);
      if (!user) {
        return '-';
      }
      return user.first_name  + ' ' + user.last_name;
    },
  },

}
</script>
<style scoped>
  .menu-date__picker {
    padding-left: 12px;
    margin-top: -22px;
    padding-right: 12px;
  }

  .select-drop-item-group__area {
    background: #e0e0e0;
  }

  .select-drop-item-sub_restaurant {
    padding-left: 16px;
  }

  .menu-interval-changer {
    max-width: 120px; padding-top: 2px;
  }

  .menu-select__area {
    width: 300px;
  }
  /* Define a class for negative amount difference (red background) */
  .negative-difference {
    background-color: #ffcccc; /* Light red background */
  }

  /* Optional: Define a class for positive amount difference (green background) */
  .positive-difference {
    background-color: #ccffcc; /* Light green background */
  }
  /* Optional: Define a class for positive amount difference (green background) */
  .zero-difference {
    background-color: #c8b3ef; /* Light green background */
  }
  .total-row {
    font-weight: bold; /* Make total row bold */
    background-color: #f5f5f5; /* Different background color for total row */
  }
  .custom-width {
    max-width: 4.76% !important;
    flex-basis: 4.76% !important;
    flex-grow: 0 !important; /* Ensure the column doesn't grow */
    padding-right: 6px !important;
    padding-left: 6px !important;
  }
  .padding-decrease {
    padding-right: 6px !important;
    padding-left: 6px !important;
  }
  @media (max-width: 600px) {
    .custom-width {
      width: 50% !important; /* Custom width for mobile */
      flex-basis: 50% !important;
      max-width: 50% !important;
      padding-right: 12px !important;
      padding-left: 12px !important;
    }
  }
</style>
